import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';

export function Categories(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Category Name',
        accessor: 'categoryName',
        Cell: (c) => {
          //console.log(c)
          return (<SiteLink to={`/admin/category/${c.row.original.categoryId}`}><b>{c.cell.value}</b></SiteLink>)
        }
      },
      // {
      //   Header: 'Status',
      //   accessor: 'statusText',
      // },
      {
        Header: 'Date Created',
        accessor: 'dateCreated',
        Cell: (c) => c.cell.value && utils.date.formatYYYYMMDD(c.cell.value)
      }
    ],
    []
  )

  // buyerEmail: "comsnack@gmail.com"
  // buyerName: "Joonchul Shin"
  // orderDate: "2020-05-21T19:36:27.7866282+00:00"
  // orderId: "2ad0c010-e4c7-4c5c-918e-0579a148f3e6"
  // orderNo: "FCCQ0001"
  // siteOrderSeqNo: 1
  // totalAmount: 1000
  // uniqueNo: "FCCQ"


  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + `/api/categoryAdmin/getList`);
    // eslint-disable-next-line
  }, []);
  
  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()){
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  return (
    <>
      <h1>Categories</h1>
      
      <div className="filter" style={{ minHeight: '30px' }}>
        <SiteLink className="btn btn-outline-primary" to="/admin/category/new">Add Category</SiteLink>
      </div>
      <Table columns={columns} data={data} />
    </>
  );
}
